import { Box, Button, CircularProgress, Dialog, Stack, Typography } from "@mui/material";

import { formatMoney } from "../../../../../shared/utils/formatMoney";

export default function SalesImportIntegrationDialog({ open, draft, regularizations, movements, loading, error, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="sales-import-integration-title"
      PaperProps={{ sx: { width: "min(92vw, 520px)", p: 3, borderRadius: "28px", bgcolor: "neutral.50" } }}
    >
      <Stack spacing={2}>
        <Typography id="sales-import-integration-title" component="h2" sx={{ fontSize: 19, fontWeight: 800, color: "primary.900" }}>
          Confirmar integración de ventas
        </Typography>
        <Typography sx={{ fontSize: 13, color: "primary.900" }}>
          Se registrarán las ventas, el consumo teórico, las regularizaciones de Stock y los ingresos en Tesorería.
        </Typography>
        <Stack spacing={0.8} sx={{ p: 2, bgcolor: "secondary.200", border: "1px solid", borderColor: "neutral.600", borderRadius: "24px" }}>
          <Typography sx={{ display: "flex", justifyContent: "space-between", gap: 2, fontSize: 13 }}><span>Comprobantes:</span> <strong>{draft?.distinctReceiptCount}</strong></Typography>
          <Typography sx={{ display: "flex", justifyContent: "space-between", gap: 2, fontSize: 13 }}><span>Importe total:</span> <strong>{formatMoney(draft?.totalSalesAmount)}</strong></Typography>
          <Typography sx={{ display: "flex", justifyContent: "space-between", gap: 2, fontSize: 13 }}><span>Regularizaciones:</span> <strong>{regularizations}</strong></Typography>
          <Typography sx={{ display: "flex", justifyContent: "space-between", gap: 2, fontSize: 13 }}><span>Movimientos de Tesorería:</span> <strong>{movements}</strong></Typography>
        </Stack>
        {loading ? <Box role="status" sx={{ p: 1.5, borderRadius: "14px", bgcolor: "secondary.100" }}>
          <Typography sx={{ fontSize: 13, fontWeight: 700 }}>Integrando ventas… No cierres esta pantalla.</Typography>
        </Box> : null}
        {error ? <Typography role="alert" sx={{ color: "error.main", fontSize: 13 }}>{error}</Typography> : null}
        <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-end" }}>
          <Button onClick={onClose} disabled={loading} sx={{ textTransform: "none", color: "primary.900" }}>Volver</Button>
          <Button onClick={onConfirm} disabled={loading} startIcon={loading ? <CircularProgress size={15} color="inherit" /> : null} sx={{ px: 2, borderRadius: "33px", bgcolor: "primary.500", color: "logoblanco", textTransform: "none", fontWeight: 800, "&:hover": { bgcolor: "primary.600" } }}>
            {loading ? "Integrando ventas…" : "Confirmar e integrar"}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
